// API 配置
export const config = {
  // 本地环境
  // API_BASE: 'http://127.0.0.1:8008',
  // 线上环境
  API_BASE: 'https://www.sunsun.site/api',

  // 前端回调地址（必须与 Casdoor 应用配置的 Redirect URL 一致）
  REDIRECT_URI: 'https://www.sunsun.site/callback',

  // Casdoor 登录接口
  CASDOOR_URL: '/casdoor',
  // Token 换取接口
  TOKEN_URL: '/auth/token',
  // 用户信息接口
  USER_URL: '/auth/user',
  // 登出接口
  LOGOUT_URL: '/logout',

  // Flower API 端点
  FLOWER_TIME_LINE: '/api/flower/time_line',
  FLOWER_TIME_LINE_LIST: '/api/flower/time_line/list',
  FLOWER_TIME_LINE_PUBLIC_LIST: '/api/flower/time_line/public_list',
  FLOWER_SHOW_IMAGE_URL: '/api/flower/time_line/show_image_url',
  FLOWER_UPDATE_SUCCULENT_PLANT: '/api/flower/update_succulent_plant',
  FLOWER_UPDATE_TIME_LINE_NODE: '/api/flower/update_time_line_node',
  FLOWER_DELETE_SUCCULENT_PLANT: '/api/flower/delete_succulent_plant',
  FLOWER_DELETE_TIME_LINE_NODE: '/api/flower/delete_timeline_node',
  FLOWER_DELETE_FLOWER_IMAGE: '/api/flower/delete_flower_image',
};
